// extracted by mini-css-extract-plugin
export default {"showCard":"CustomJudgementTwo_showCard__6Q5yt","editStyle":"CustomJudgementTwo_editStyle__iWibG","font20":"CustomJudgementTwo_font20__GPqEP"};